import { gql } from '@apollo/client';

export const UPDATE_INVESTMENT_STATUS = gql`
  mutation UpdateInvestmentStatus($input: UpdateInvestmentStatusInput!) {
    updateInvestmentStatus(input: $input) {
      statusCode
      message
      error
      investment {
        id
        status
      }
    }
  }
`;
